import { z } from 'zod';
import { ROLES } from './roles';
import { THEMES } from './team';

/** Error body returned by every non-2xx API response. */
export const apiErrorSchema = z.object({
  error: z.object({ code: z.string(), message: z.string(), details: z.unknown().optional() }),
});
export type ApiError = z.infer<typeof apiErrorSchema>;

export const meSchema = z.object({
  user: z.object({
    id: z.uuid(),
    email: z.email(),
    name: z.string(),
    role: z.enum(ROLES),
    timezone: z.string(),
    avatarUrl: z.string().nullable(),
  }),
  tenant: z.object({
    id: z.uuid(),
    name: z.string(),
    timezone: z.string(),
    weekStart: z.number().int().min(0).max(6),
    currency: z.string().length(3),
    theme: z.enum(THEMES),
    requireProject: z.boolean(),
  }),
});
export type Me = z.infer<typeof meSchema>;

/** Header every mutating request must carry (CSRF defence alongside SameSite cookies). */
export const CSRF_HEADER = 'x-taim-csrf';
